// extracted by css-extract-rspack-plugin
export default {"dragHandle":"dragHandle-J6Nup3"};